import { render, staticRenderFns } from "./QuizItem.vue?vue&type=template&id=3d4d3918&scoped=true&"
import script from "./QuizItem.vue?vue&type=script&lang=js&"
export * from "./QuizItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d3918",
  null
  
)

export default component.exports